<script setup lang="ts">
import { useDialog, useMetrics } from "#imports";
import MPBookmark from "../widgets/MPBookmark.vue";
import MPImg from "../widgets/MPImg.vue";

const props = defineProps<{
  spotId: string;
}>();
const { closeDialog } = useDialog();
const { trackEvent } = useMetrics();

defineExpose({
  closed: (userAction: boolean) => {
    if (userAction) {
      trackEvent("bookmark_spot_dialog_closed");
    }
  },
});

const handleSpotBookmarked = () => {
  trackEvent("spot_bookmarked_from_dialog", {
    spot_id: props.spotId,
  });
  closeDialog();
};
</script>

<template>
  <div class="bookmark-spot-dialog">
    <div class="vectors">
      <MPImg
        class="bottom-vector"
        src="/media/images/bookmark-spot-bottom-vector.svg"
      />
      <MPImg
        class="top-vector"
        src="/media/images/bookmark-spot-top-graphic.svg"
      />
      <MPImg
        class="right-vector"
        src="/media/images/bookmark-spot-right-vector.svg"
      />
      <MPImg
        class="right-graphic"
        src="/media/images/bookmark-spot-right-graphic.svg"
      />
    </div>
    <div class="bookmark-dialog-content">
      <h4>Save this Spot for later?</h4>
      <p>
        Tap "Save" to add this spot to your saved places, making it easy to
        navigate back or share with friends
      </p>
      <p>
        <img src="/media/images/compas-arrow.svg" />
        Save it now so you don’t forget!
      </p>
      <MPBookmark
        size="large"
        bookmark="spot_bookmarks"
        backgroundColor="var(--color-indigo-100)"
        iconColor="var(--color-indigo-600)"
        :id="props.spotId"
        @completed="handleSpotBookmarked"
      />
    </div>
  </div>
</template>
<style lang="postcss" scoped>
@import "assets/css/breakpoints.pcss";

.bookmark-spot-dialog {
  background-color: var(--color-indigo-700);
  width: 100%;
  max-width: 30.0625rem;
  overflow: hidden;
}

.vectors {
  position: absolute;
  inset: 0;
  display: grid;

  .bottom-vector {
    position: absolute;
    bottom: 0;
  }
  .top-vector {
    place-self: start;
  }
  .right-vector {
    position: absolute;

    top: 0;
    right: 0;
  }
  .right-graphic {
    place-self: start end;
  }
}

.bookmark-dialog-content {
  padding-top: 1.31rem;
  padding-inline: 1.59rem;
  padding-bottom: 2.94rem;
  color: var(--color-indigo-50);
  @mixin screen sm {
    text-align: center;
    padding-bottom: 4.94rem;
    padding-inline: 3.19rem;
  }

  h4 {
    margin-bottom: 1.37rem;
    font-family: "DM Sans";
    font-size: 1.9375rem;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  }
  p {
    font-family: "Hanken Grotesk";
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }

  p:last-of-type {
    margin-bottom: 2.25rem;
  }

  :deep(div) {
    width: 100% !important;
  }
  div:deep(button) {
    width: 100% !important;
    color: var(--color-indigo-600) !important;
  }
}
</style>
